import React from 'react';
import './SignalStrength.css';

export const SignalStrength = ({ type, value }) => {
    
    let progressBar = parseInt(value);

    if ( progressBar < 0 ){
        progressBar = `${parseInt(value) + 100}%`;
    } else {
        progressBar = `${parseInt(value)}%`;
    }

    return(
        <>
           <div id="signal-strength" className={`signal-strength--${type}`} style={{width: "100%"}}>
                <div className="signal-strength__background ">
                    <div className="signal-strength__progress" style={{width: progressBar}}>
                    </div>
                    <p className="signal-strength__value">{value}</p>
                </div>
           </div>
        </>
    );
}

SignalStrength.defaultProps = {
    value: 0,
}